import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IInventoryCategory } from '@inventory/models/inventory';
import { IInventoryCategoryEditForm } from '@inventory/models/inventory-forms';
import { InventoryCategoriesService } from '@inventory/services/inventory-categories/inventory-categories.service';
import { StandardControlComponent } from '@shared/components/forms/standard-control/standard-control.component';
import { SwitchControlComponent } from '@shared/components/forms/switch-control/switch-control.component';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';
import { ToastTypes } from '@shared/models/toast';
import { OffcanvasService } from '@shared/services/offcanvas/offcanvas.service';
import { ToastService } from '@shared/services/toast/toast.service';

@Component({
	selector: 'app-inventory-category-details-offcanvas',
	imports: [CommonModule, StandardControlComponent, TextareaControlComponent, SwitchControlComponent],
	templateUrl: './inventory-category-details-offcanvas.component.html',
	styleUrl: './inventory-category-details-offcanvas.component.scss',
	host: {
		class: 'h-100',
		style: 'display: contents',
	},
})
export class InventoryCategoryDetailsOffcanvasComponent implements OnInit {
	@Input() inventoryCategory: IInventoryCategory;

	private inventoryCategoriesService = inject(InventoryCategoriesService);
	private offcanvasService = inject(OffcanvasService);
	private toastService = inject(ToastService);

	form: FormGroup<IInventoryCategoryEditForm>;

	isSubmitting: boolean = false;

	ngOnInit(): void {
		this.form = new FormGroup<IInventoryCategoryEditForm>({
			name: new FormControl<string | null>(null, [Validators.required, Validators.minLength(2), Validators.maxLength(100)]),
			description: new FormControl<string | null>(null, [Validators.maxLength(500)]),
			archived: new FormControl<boolean | null>(false),
		});

		this.form.setValue({
			name: this.inventoryCategory.name,
			description: this.inventoryCategory.description,
			archived: this.inventoryCategory.archived,
		});
	}

	close(): void {
		this.offcanvasService.dismissLast();
	}

	submit(): void {
		if (this.form.invalid) {
			return;
		}

		this.isSubmitting = true;

		this.inventoryCategoriesService
			.updateInventoryCategory(this.inventoryCategory.id as string, this.form)
			.then(() => {
				this.isSubmitting = false;
				this.offcanvasService.dismissLast();
			})
			.catch((error) => {
				console.error('Error updating inventory category:', error);
				this.isSubmitting = false;
				this.toastService.showToast({
					title: 'Inventory Category',
					message: `Failed to update inventory category: ${error.message}`,
					type: ToastTypes.ERROR,
				});
			});
	}
}
